
import HeaderPage from "../HeaderPage";
import Sidebar from "../Sidebar";
import MaritimeFreightSearchList from "./components/MaritimeFreightSearchList";

const MaritimeFreightSearch = () => {
  return (
    <div className="flex-dashboard">
      <Sidebar elementoAtivo="schedule" />
      <main>
        <HeaderPage nomeOpcao="Schedules" />
        <div className="main-content">
         <MaritimeFreightSearchList />
        </div>
      </main>
    </div>
  );
};

export default MaritimeFreightSearch;
